import React, { useMemo } from 'react';
import classnames from 'classnames';
import * as styles from './copy.module.scss';

const Copy = ({ copy }) => {
  const currentYear = useMemo(() => {
    const date = new Date();

    return date.getFullYear();
  }, []);

  return (
    <p className={classnames(styles.copy, 'cr-sub cr-opacity-02')}>
      {currentYear} {copy.text}
    </p>
  );
};

export default Copy;
